import admin_avatar_header from "../../../assets/images/avatar.svg";
import Layout from "../layout/Layout";
import { useFormik } from "formik";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { blogPost } from "../../../Redux/Actions/admin/adminPanel";
import { useNavigate } from "react-router-dom";
import RTE from "./Rte";
import { startstopLoading } from "../../../Redux/Reducers/globalSlice";
import { toastInfo } from "../../../Redux/Reducers/admin/adminPanelSlice";

export default function CreateBlog() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [img, setImg] = useState();
  const [htmlBlogContent, setHtmlBlog] = useState();

  const handleHtml = (html) => {
    setHtmlBlog(html);
  };

  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = "Required";
    }
    if (!values.author) {
      errors.author = "Required";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      author: "",
      blogContent: "",
    },

    validate,
    onSubmit: async (values) => {
      let formData = new FormData();
      formData.append("file", img);
      formData.append("title", values.title);
      formData.append("author", values.author);
      formData.append("blogContent", htmlBlogContent);

      try {
        if (img) {
          dispatch(startstopLoading(true));
          await dispatch(blogPost(formData)).then((res) => {
            if (
              res?.payload?.success == true ||
              res?.payload?.success == false
            ) {
              dispatch(startstopLoading(false));
              navigate("/admin/blog");
            }
          });
        } else {
          toastInfo("Please provide an Image")
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Layout>
      <div id="layout-wrapper" className="bg-dash admin-table">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* <!-- start page title --> */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <div>
                      <span className="small_text">Blogs</span>
                      <h4 className="mb-sm-0 font-size-28">New Blog</h4>
                    </div>
                    <div className="page-title-right">
                      {/* <!-- App Search--> */}
                      <form className="app-search d-none d-lg-block ">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="position-relative w-100">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                            />
                            <span className="bx bx-search"></span>
                          </div>
                          <img
                            src={admin_avatar_header}
                            className="avata_serch"
                            alt=""
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="tbl_user_info">
                    <div className="row">
                      <form onSubmit={formik.handleSubmit}>
                        <div className="col-md-8">
                          <div className="form-group mb-3">
                            <input
                              onChange={formik.handleChange}
                              name="title"
                              type="text"
                              className="form-control-new"
                              placeholder="Blog Title"
                            />
                            {formik.errors.title ? (
                              <p style={{ color: "red" }}>
                                {formik.errors.title}*
                              </p>
                            ) : null}
                          </div>
                          <div className="form-group mb-3">
                            <input
                              onChange={formik.handleChange}
                              name="author"
                              type="text"
                              className="form-control-new"
                              placeholder="Author"
                            />
                            {formik.errors.author ? (
                              <p style={{ color: "red" }}>
                                {formik.errors.author}*
                              </p>
                            ) : null}
                          </div>
                          <div className="form-group mb-5">
                            <input
                              onChange={(e) => setImg(e.target.files[0])}
                              type="file"
                              accept="image/*"
                              className="blog-upload-input"
                              placeholder="Upload Image"
                            />
                            <div className="blog-upload-img form-control-new">
                              {!img ? "Upload Image(Max size:5MB)" : img.name}
                            </div>
                          </div>
                          <div>
                            <RTE htmlText={handleHtml} />
                          </div>
                          <div
                            className="editor-controls"
                            id="editor-controls"
                          ></div>

                          <div className="d-flex justify-content-end">
                            <button
                              type="submit"
                              style={{ border: "none" }}
                              className="blog-post-submt-btn"
                            >
                              Post
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- blog post row end --> */}
            </div>
            {/* <!-- container fluid --> */}
          </div>
          {/* <!-- End Page-content --> */}
        </div>
        {/* <!-- end main content--> */}
      </div>
    </Layout>
  );
}
